import React from 'react';
import { MagicalTicTacToeGame } from './components/MagicalTicTacToeGame';
import { GameAudioProvider } from './components/GameAudioProvider';

function App() {
  return (
    <GameAudioProvider>
      <div>
        <MagicalTicTacToeGame />
      </div>
    </GameAudioProvider>
  );
}

export default App;